/* globals Power2, Power0, TimelineMax */
$(function() {
	// @codekit-prepend 'js/functions.js'
    // @codekit-prepend 'js/dropdown.js'
	
    
	// @codekit-prepend 'js/slider.js'
	// @codekit-prepend 'js/auto-slider.js'

	// @codekit-prepend 'js/header.js'
	// @codekit-prepend 'js/floating-summary.js'
	// @codekit-prepend 'js/home.js'
	// @codekit-prepend 'js/contact.js'
	// @codekit-prepend 'js/cart.js'
	// @codekit-prepend 'js/products.js'

});